import { useLocation } from "react-router-dom";

export function Footer() {
  const location = useLocation();
  // The visualizations page (/enthea) has a full-screen canvas with a fixed
  // bottom controls bar. The corner warning would overlap that bar on mobile,
  // so we suppress it there. The bar itself stays available on every other page.
  const hideWarning = location.pathname.startsWith("/enthea");

  return (
    <footer className="relative bg-black text-white pt-24 pb-32 sm:pt-32 sm:pb-40 overflow-hidden">
      <div className="relative z-10 container mx-auto px-6 flex flex-col items-center gap-16 sm:gap-24">
        {/* Bardo Thödol quote — sits between the curator portrait (Portfolio)
            and the scarab below. Spaced out so it reads as its own beat. */}
        <blockquote className="max-w-2xl text-center font-serif text-lg sm:text-2xl leading-relaxed text-amber-300/95 italic">
          "You are facing the Primary Clear Light. Be alert and attentive to
          all that happens. You can now see and hear ultimate reality."
          <cite className="not-italic block mt-6 text-xs sm:text-sm tracking-[0.35em] uppercase text-amber-400/70 font-medium">
            — Bardo Thödol
          </cite>
        </blockquote>

        {/* Scarab mark — decorative anchor at the foot of the page */}
        <img
          src="/images/scarab.png"
          alt=""
          aria-hidden
          className="w-32 h-32 sm:w-40 sm:h-40 rounded-full object-cover shadow-[0_0_60px_rgba(212,175,55,0.25)]"
          loading="lazy"
        />
      </div>

      {/* Warning in bottom right corner */}
      {!hideWarning && (
        <div className="fixed bottom-4 right-4 z-40">
          <span className="text-red-500 text-xs font-bold bg-black/80 px-3 py-1 rounded-full border border-red-500/30">
            NOT FOR HUMAN CONSUMPTION
          </span>
        </div>
      )}
    </footer>
  );
}
